module.exports = __webpack_public_path__ + "static/img/github_image.9abb0ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/1x/github_image.png
// module id = +J1d
// module chunks = 1